import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Leaflet ships its own stylesheet; without it the map renders as a grey
// box with the tiles stacked in the wrong place. One import, here, rather
// than per component that happens to use a map.
import 'leaflet/dist/leaflet.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
